import styled from '@emotion/styled';

import Alert from 'components/global/Alert';
import Icon from 'components/global/Icon';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	display: flex;
	flex-direction: row;
	height: 100%;
`;
export const Column = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	width: 0;
`;
export const Main = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	background: var(--background-1);
	position: relative;
	overflow: auto;

	> div {
		padding: var(--padding-5);
		display: flex;
		flex-direction: column;
		height: 100%;
		overflow: auto;
		overflow-x: hidden;

		@media ${Breakpoints.mobile} {
			padding: 0;
		}
	}
`;

export const TabTableContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: auto;
`;

export const MobileShadow = styled.div`
	display: ${({ isopen }) => (!isopen ? 'none' : 'block')};

	@media ${Breakpoints.mobile} {
		background-color: #00000030;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100dvh;
		z-index: var(--z-index-8);
	}
`;

export const AlertFlexDiv = styled.div`
	display: flex;
	align-items: center;

	.button {
		.button-text,
		.button-icon {
			color: var(--red);
		}

		:hover {
			.button-text,
			.button-icon {
				color: var(--red-hover) !important;
			}
		}
	}
`;

export const AlertContainer = styled(Alert)`
	display: flex;
	justify-content: space-between;
	padding: var(--padding-1) var(--padding-3);
	margin: 1rem 1rem 0 1rem;
`;

export const BlackIcon = styled(Icon)`
	margin-left: var(--padding-1);
	border-right: 1px solid var(--black);
	padding-right: var(--padding-1);
`;
